import reducer from './reducer';
import * as authActions from './actions';

export {
  authActions,
};

export default reducer;
